<div class="outer-container">
  <div>
    <div class="voicemailtitile">Voicemails</div>
    <div class="voice-mail-count voicemail-div" *ngIf="vMailCount>0">
      {{vMailCount}}
    </div>
  </div>
  <span class="close" (click)="closeVoicemailsPopup()">X</span>
  <div class="console-container">
    <div class="input-wrapper">
      <app-console-search
        [findOptions]="findOptions"
        [headercount]="headercount"
        [showHideHeaderColumnCount]="false"
        (clearSearchBoxEvent)="clearSearchBox()"
        (clearFilterEvent)="clearFilter()"
        (applyFilterByFieldEvent)="applyFilterByField($event)"
      >
      </app-console-search>
    </div>
    <div class="table-wrapper">
      <p-table
        [columns]="cols"
        [value]="voiceMailList"
        [lazy]="true"
        (onLazyLoad)="loadVoicemail($event)"
        dataKey="id"
        [tableStyle]="{ 'min-width': '50rem' }"
        [paginator]="true"
        [rows]="10"
        [totalRecords]="totalRecords"
        [loading]="loading"
        selectionMode="single"
        (onRowSelect)="onRowSelect($event)"
        [scrollable]="true"
        [style]="{ width: '100%' }"
        [(first)]="first"
        [scrollHeight]="innerHeight + 'vh'"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of cols">
              <th *ngIf="!col?.hide">
                {{ col.label }}
                <span class="fts">
                  <!-- <span class="filter" *ngIf="col.showFilter" (click)="toggleCustomColumnFilter(col.name)"> -->
                    <!-- <span class="filter" [hidden]="!col.showFilter" (click)="toggleCustomColumnFilter(col.name)"> -->
          <span class="filter" *ngIf="col.showFilter" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation(); toggleCustomColumnFilter(col.name)">
                    <ng-container *ngIf="col.filterVals; else notSelected">
                      <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                    </ng-container>
                    <ng-template #notSelected>
                      <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter.png" />
                    </ng-template>
                  </span>

                  <span class="sort" (click)="sortByColumn(col.name)">
                    <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                      <ng-container *ngIf="col.isAsc; else falseBlock">
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                      </ng-container>
                      <ng-template #falseBlock>
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                      </ng-template>
                    </ng-container>

                    <ng-template #others>
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                    </ng-template>
                  </span>
                </span>
              </th>
            </ng-container>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <ng-container *ngFor="let col of cols">
              <td *ngIf="!col?.hide && col.name !== 'Status'">
                {{ col?.type === 'date' ? (rowData[col.name] | custdate) : rowData[col.name] }}
              </td>
              <td *ngIf="col.name === 'Status'">
                <span *ngIf="rowData[col.name] === 'New'" class="status-new"></span>
                <span *ngIf="rowData[col.name] === 'Reviewed'" class="status-reviewed"></span>
                <span *ngIf="rowData[col.name] === 'Responded'" class="status-responded"></span>
                {{ rowData[col.name] }}
              </td>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">No Data Available</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
